<div class="custom" style="zoom: 0.7">
  <mat-spinner style="z-index: 99999999 !important" diameter="50"></mat-spinner>
</div>
